import type { DecorationGridLayout, DecorationStates } from "./types";

const NO_STATES: DecorationStates = Object.freeze({});

export const layoutSize = (layout: DecorationGridLayout | null | undefined, index: number): string | null => {
	const pattern = layout?.pattern ?? [];
	if (index < pattern.length) return pattern[index] ?? null;
	return layout?.repeat && pattern.length > 0 ? (pattern[index % pattern.length] ?? null) : null;
};

export const sizeStates = (size: string | null | undefined): DecorationStates => (size ? { [size]: true } : NO_STATES);
